export enum EnumStatusContato {
  Campeao = 'CAMPEAO',
  Fiel = 'FIEL',
  Novo = 'NOVO',
  Esfriando = 'ESFRIANDO',
  Sumido = 'SUMIDO',
  Perdido = 'PERDIDO',
  SemPedido = 'SEM_PEDIDO'
}

export const SEGMENTOS_EM_DIA = [EnumStatusContato.Campeao, EnumStatusContato.Fiel, EnumStatusContato.Novo];
export const SEGMENTOS_TODOS = [
  EnumStatusContato.Esfriando, EnumStatusContato.Sumido, EnumStatusContato.Novo, EnumStatusContato.Fiel,
  EnumStatusContato.Campeao, EnumStatusContato.Perdido, EnumStatusContato.SemPedido
];

export const NOME_DO_SEGMENTO: Record<EnumStatusContato, string> = {
  [EnumStatusContato.Campeao]: 'Campeões',
  [EnumStatusContato.Fiel]: 'Fiéis',
  [EnumStatusContato.Novo]: 'Novos',
  [EnumStatusContato.Esfriando]: 'Esfriando',
  [EnumStatusContato.Sumido]: 'Sumidos',
  [EnumStatusContato.Perdido]: 'Perdidos',
  [EnumStatusContato.SemPedido]: 'Sem pedido'
};
